var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('apexchart',{attrs:{"height":"100%","options":_vm.OPCOES,"series":_vm.SERIES}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }